/* Change this file to get your personal Porfolio */

import { localizeData } from "./i18n";

// Website related settings
const settings = {
  isSplash: true,
};

//SEO Related settings
const seo = {
  title: "Samer Jasim | Software Solutions Developer",
  description:
    "Portfolio of Samer Jasim, a software solutions developer specializing in administrative and educational systems, web development, databases, servers, and hosting.",
  og: {
    title: "Samer Jasim Portfolio",
    type: "website",
    url: "https://samr.work/",
  },
};

//Home Page
const greeting = {
  title: "Samer Jasim",
  logo_name: "Samer Jasim ",
  nickname: "Software Solutions Developer",
  subTitle:
    "Specialized in requirements analysis, design, and development of administrative and educational systems. I transform operational needs into practical software solutions that improve efficiency and reduce time and effort.",
  resumeLink: "",
  portfolio_repository: "",
  githubProfile: "",
};

const socialMediaLinks = [
  {
    name: "Facebook",
    link: "https://facebook.com/sjk050",
    fontAwesomeIcon: "fa-facebook-f",
    backgroundColor: "#1877F2",
  },
  {
    name: "Instagram",
    link: "https://instagram.com/sjk050",
    fontAwesomeIcon: "fa-instagram",
    backgroundColor: "#E4405F",
  },
  {
    name: "Telegram",
    link: "https://t.me/sjk050",
    fontAwesomeIcon: "fa-telegram-plane",
    backgroundColor: "#229ED9",
  },
];

const skills = {
  data: [
    {
      title: "I turn repetitive tasks into software that saves you time",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Share your workflow, requirements, and the forms and records you use.",
        "⚡ I study each step, document the details, and define the most suitable solution for your work.",
        "⚡ I build and test a digital product that simplifies your tasks, then refine it with your feedback.",
      ],
      softwareSkills: [
        {
          skillName: "Requirements Analysis",
          fontAwesomeClassname: "mdi:clipboard-text-search-outline",
          style: {
            color: "#C6A15B",
          },
        },
        {
          skillName: "System Design",
          fontAwesomeClassname: "mdi:sitemap-outline",
          style: {
            color: "#C6A15B",
          },
        },
        {
          skillName: "Custom Software",
          fontAwesomeClassname: "mdi:application-cog-outline",
          style: {
            color: "#C6A15B",
          },
        },
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Modern, responsive websites and web applications tailored to your business.",
        "⚡ Mobile applications for Android and iOS.",
        "⚡ Specialized tools built for your specific tasks and workflows.",
      ],
      softwareSkills: [
        {
          skillName: "Web Applications",
          fontAwesomeClassname: "mdi:web",
          style: {
            color: "#C6A15B",
          },
        },
        {
          skillName: "Mobile Applications",
          fontAwesomeClassname: "mdi:cellphone",
          style: {
            color: "#C6A15B",
          },
        },
        {
          skillName: "Specialized Tools",
          fontAwesomeClassname: "mdi:tools",
          style: {
            color: "#C6A15B",
          },
        },
      ],
    },
    {
      title: "Environment & Hosting Management",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Managing Linux servers and preparing application deployment environments.",
        "⚡ Deploying and managing websites and their hosting settings.",
        "⚡ Moving websites and databases to new servers, with backups and checks to minimize downtime.",
      ],
      softwareSkills: [
        {
          skillName: "Linux",
          fontAwesomeClassname: "simple-icons:linux",
          style: {
            color: "#C6A15B",
          },
        },
        {
          skillName: "SSH",
          fontAwesomeClassname: "mdi:console",
          style: {
            color: "#C6A15B",
          },
        },
        {
          skillName: "Caddy Server",
          fontAwesomeClassname: "mdi:server-network",
          style: {
            color: "#C6A15B",
          },
        },
      ],
    },
  ],
};

const technologies = {
  title: "Skills & Technologies",
  groups: [
    {
      title: "Programming Skills",
      icon: "mdi:code-braces",
      items: [
        "Systems analysis and design",
        "Software application development",
        "Database design",
        "Administrative process automation",
        "AI model training",
        "Programming languages & technologies: JavaScript, PHP, Node.js, Bun, MySQL, SQLite3",
      ],
    },
    {
      title: "Environment & Hosting Management",
      icon: "mdi:server-network",
      items: [
        "Linux environment management",
        "SSH connections",
        "Caddy web server",
        "Hosting management and deployment",
        "Website penetration testing and security",
      ],
    },
    {
      title: "Academic Skills",
      icon: "mdi:flask-outline",
      items: [
        "Scientific research skills",
        "Data collection",
        "Statistical analysis and data interpretation",
        "Laboratory work",
        "Sample and solution preparation",
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [],
};

const degrees = {
  degrees: [
    {
      title: "Bachelor's Degree in the College of Science",
      subtitle: "Class Rank: 4",
      duration: "",
      descriptions: [],
    },
  ],
};

const certifications = {
  certifications: [],
};

// Experience Page
const experience = {
  title: "Experience & Practical Projects",
  subtitle: "",
  description: "",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Professional Experience",
      work: true,
      experiences: [
        {
          title: "Government Employee",
          company: "Ministry of Education",
          company_url: "",
          logo_path: "",
          duration: "October 2024 — Present",
          location: "",
          description: [
            "Transforming routine procedures into practical software solutions that reduce effort and time, improve efficiency, and speed up transactions.",
            "Preparing, organizing, archiving, and tracking incoming and outgoing official correspondence.",
            "Receiving students and employees, answering inquiries, and guiding them through the appropriate administrative procedures.",
            "Following up on graduate and employee transactions while organizing student records and updating related data.",
          ],
          color: "#C6A15B",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description: "",
  avatar_image_path: "projects_image.svg",
};

const personalProjects = [
  {
    name: "Madali Bot",
    image: "/media/bots/madali.jpg",
    url: "https://t.me/mdjkbot",
    handle: "@mdjkbot",
  },
  {
    name: "SnapDoc Bot",
    image: "/media/bots/snapdoc.jpg",
    url: "https://t.me/arwdbot",
    handle: "@arwdbot",
  },
];

const publicationsHeader = {
  title: "Project & Work History",
  description: "",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "sina-university-website-migration",
      name: "Sina University Website Migration",
      date: "June 2026",
      description:
        "Configured and provisioned the new server, executing a secure, zero-downtime migration of the entire website and database to maintain continuous operational service.",
      icon: "fa-solid:server",
      rating: 5,
      reviewUrl: "https://mostaql.com/u/Sjk9/reviews/9834804",
    },
    {
      id: "saudi-local-guide",
      name: "Saudi Arabia Local Guide Application",
      date: "March 2024 — April 2024",
      description:
        "Developed the application interfaces and integrated them with database backends while enhancing performance speeds, offering an intuitive design tailored to local users.",
      icon: "fa-solid:map-marked-alt",
      rating: 5,
      reviewUrl: "https://mostaql.com/u/Sjk9/reviews/7507023",
    },
    {
      id: "apartment-reservation-system",
      name: "Apartment Reservation Management System",
      date: "April 2024 — May 2024",
      description:
        "End-to-end design and development of an intelligent booking system, featuring an interactive administrative dashboard to monitor vacancy statuses and handle reservations utilizing PHP and MySQL.",
      icon: "fa-solid:key",
      rating: 5,
      reviewUrl: "https://mostaql.com/u/Sjk9/reviews/7570407",
    },
  ],
};

// Products Page
const products = {
  title: "Products",
  emptyState: "Coming Soon",
  // Each product can define: slug, name, description, image, icon, features, and downloadUrl.
  items: [
    {
      slug: "darajat",
      name: "Darajat",
      description:
        "A school administration program for managing grades and issuing graduation confirmations.",
      icon: "mdi:school-outline",
      logo: "/media/darajat/logo.ico",
      image: "/media/darajat/results.png",
      features: ["School grade management", "Issuing graduation confirmations"],
      downloadUrl: "https://dow.samr.work",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    sectionTitle: "Contact Information",
    directTitle: "Direct Contact",
    whatsappText: "Message via WhatsApp",
    whatsappUrl: "https://wa.me/9647713380002",
    phoneLabel: "Phone",
    phone: "07713380002",
    phoneUrl: "tel:+9647713380002",
    primaryEmailLabel: "Primary Email",
    primaryEmail: "samer@samr.work",
    alternativeEmailLabel: "Alternative Email",
    alternativeEmail: "samerjk07@gmail.com",
  },
};

const localizedSeo = localizeData(seo);
const localizedGreeting = localizeData(greeting);
const localizedSocialMediaLinks = localizeData(socialMediaLinks);
const localizedSkills = localizeData(skills);
const localizedTechnologies = localizeData(technologies);
const localizedPersonalProjects = localizeData(personalProjects);
const localizedCompetitiveSites = localizeData(competitiveSites);
const localizedDegrees = localizeData(degrees);
const localizedCertifications = localizeData(certifications);
const localizedExperience = localizeData(experience);
const localizedProjectsHeader = localizeData(projectsHeader);
const localizedPublicationsHeader = localizeData(publicationsHeader);
const localizedPublications = localizeData(publications);
const localizedProducts = localizeData(products);
const localizedContactPageData = localizeData(contactPageData);

export {
  settings,
  localizedSeo as seo,
  localizedGreeting as greeting,
  localizedSocialMediaLinks as socialMediaLinks,
  localizedSkills as skills,
  localizedTechnologies as technologies,
  localizedPersonalProjects as personalProjects,
  localizedCompetitiveSites as competitiveSites,
  localizedDegrees as degrees,
  localizedCertifications as certifications,
  localizedExperience as experience,
  localizedProjectsHeader as projectsHeader,
  localizedPublicationsHeader as publicationsHeader,
  localizedPublications as publications,
  localizedProducts as products,
  localizedContactPageData as contactPageData,
};
